import flow from './newFlow';
export const getBotNode = (id) => {
    const foundNode = flow.find(node => node.id === id);
    if (!foundNode)
        throw Error('Cannot find bot node by ID');
    return foundNode;
};
